import React, { useEffect, useState } from "react";

const HeaderMapping = ({ fileData, eventId, onMappingComplete, onBack }) => {
  const [mappings, setMappings] = useState({});
  const [fields, setFields] = useState([]);

  useEffect(() => {
    const fetchFields = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/forms/single/${eventId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        setFields(Object.keys(data)); // field names as keys
      } catch (err) {
        console.error("Failed to fetch form fields", err);
      }
    };
    fetchFields();
  }, [eventId]);

  useEffect(() => {
    const initial = {};
    fileData.headers.forEach((header) => {
      fields.forEach((field) => {
        if (!initial[field] && header.toLowerCase().includes(field.toLowerCase())) {
          initial[field] = header;
        }
      });
    });
    setMappings(initial);
  }, [fileData.headers, fields]);

  const handleChange = (fieldName, selectedColumn) => {
    setMappings(prev => ({
      ...prev,
      [fieldName]: selectedColumn,
    }));
  };

  const allMapped = fields.length > 0 && fields.every((field) => mappings[field]);

  return (
    <div>
      <h3>Map your file headers to system fields</h3>
      <button className="btn btn-sm btn-secondary mt-3" onClick={onBack}>← Back</button>
      {fields.map((field) => (
        <div key={field} className="mapping-row grid grid-cols-1 md:grid-cols-5 gap-4 items-center mt-3">
          <div className="col-span-1 md:col-span-1 m-1">
            <label className="block text-sm font-medium text-gray-700"><b>{field}</b></label>
          </div>
          <div className="col-span-1 md:col-span-3 form-group">
            <select
              className="form-control"
              value={mappings[field] || ""}
              onChange={(e) => handleChange(field, e.target.value)}
            >
              <option value="">Select column</option>
              {fileData.headers.map((header, idx) => (
                <option key={idx} value={header}>
                  {header}
                </option>
              ))}
            </select>
          </div>
        </div>
      ))}
      <button className="btn btn-sm btn-primary mt-4" onClick={() => onMappingComplete(mappings)} disabled={!allMapped}>
        Continue →
      </button>
    </div>
  );
};

export default HeaderMapping;